<template>
  <section class="section__items">
    <div class="category-filter">
      <button
          v-for="cat in categories"
          :key="cat"
          @click="selectedCategory = cat"
          :class="{ active: selectedCategory === cat }"
      >
        {{ cat }}
      </button>
    </div>

    <div
        v-for="kit in filteredKits"
        :key="kit.id"
        class="card"
    >
      <img :src="kit.image" :alt="kit.name" id="kit-image" />
      <h3>{{ kit.name }}</h3>
      <span class="text__green">In Stock</span>

      <div class="cart">
        <div class="round" @click="decrementQuantity(kit.id)">-</div>
        <h2>{{ kit.quantity }}</h2>
        <div class="round" @click="incrementQuantity(kit.id)">+</div>
      </div>

      <button class="cart__button" @click="addToCart(kit)">Add to Cart</button>
    </div>
  </section>
</template>


<script>
import { db } from '@/firebase'
import { collection, getDocs, orderBy, query } from 'firebase/firestore'

export default {
  name: 'Items',
  data() {
    return {
      kits: [],
      selectedCategory: 'All',
    };
  },
  computed: {
    categories() {
      return ['All', 'PvP', 'Armor', 'Tools', 'Consumables', 'Blocks', 'Misc']
    },
    filteredKits() {
      if (this.selectedCategory === 'All') return this.kits
      return this.kits.filter(kit => kit.categories?.includes(this.selectedCategory.toLowerCase()))
    }
  },
  async created() {
    await this.fetchKits()
  },
  methods: {
    async fetchKits() {
      try {
        const q = query(collection(db, 'kits'), orderBy('timestamp', 'desc'))
        const snapshot = await getDocs(q)
        this.kits = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          quantity: 1,
        }))
      } catch (error) {
        console.error('Kits çekilemedi:', error)
      }
    },
    incrementQuantity(kitId) {
      const kit = this.kits.find(k => k.id === kitId);
      if (kit) {
        kit.quantity += 1;
      }
    },
    decrementQuantity(kitId) {
      const kit = this.kits.find(k => k.id === kitId);
      if (kit && kit.quantity > 1) {
        kit.quantity -= 1;
      }
    },
    addToCart(kit) {
      const cartItem = { ...kit };
      this.$store.dispatch('addItemToCart', cartItem);
    }
  }
};
</script>

<style scoped>
.section__items {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3rem 0 5rem;
    flex-wrap: wrap;
}

.section__items .card {
    display: flex;
    align-items: center;
    flex-direction: column;
    border: 1px solid cornflowerblue;
    width: 300px;
    height: 570px;
    margin-left: 1rem;
    margin-right: 1rem;
    border-radius: 1rem;
    padding: 20px;
    margin-bottom: 2rem;
}

.category-filter {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  gap: 1rem;
}

.category-filter button {
  background-color: transparent;
  color: white;
  border: 1px solid cornflowerblue;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.category-filter button.active,
.category-filter button:hover {
  background-color: cornflowerblue;
  color: black;
}

#kit-image {
    margin-top: 30px;
    width: 100%;
    height: auto;
    max-width: 350px;
    object-fit: cover;
}

.icon {
    margin-top: 30px;
    width: 140px;
}

.section__items div h3 {
    color: #fff;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-weight: 600;
}

.text__green {
    color: #33c608;
    margin-top: 1.5rem;
    margin-right: 180px;
}

.cart {
    margin-top: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.cart .round {
    border: 1px solid #fff;
    border-radius: 50%;
    color: #fff;
    padding: 0.3rem 1.2rem;
    font-size: 2rem;
    cursor: pointer;
}

.cart h2 {
    color: #fff;
    font-size: 3rem;
    margin: 0 3rem;
}

.cart__button,
.check__button {
    margin-top: 2rem;
    padding: 0.7rem 4rem;
    border-radius: 1rem;
    color: #fff;
    text-align: center;
    text-decoration: none;
    display: block;
    width: 100%;
    text-transform: uppercase;
    font-weight: bold;
}

.cart__button {
    border: 1px solid #fff;
    background-color: transparent;
}

.check__button {
    background-color: #00ADF0;
    margin-top: 1rem;
}

.cart__button:hover, .check__button:hover {
    opacity: 0.8;
}

@media (max-width: 909px) {
    .card {
        width: 100%;
        max-width: 350px; /* Ensure card does not exceed this width */
        margin: 0.5rem; /* Reduce margin on smaller screens */
    }

    .cart h2 {
        font-size: 2.5rem;
      }
}
</style>
